import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="sobre" className="py-24 bg-inkova-primary text-white relative overflow-hidden" data-id="element-17">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-18">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-inkova-accent rounded-full opacity-10 blur-3xl" data-id="element-19"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-inkova-accent rounded-full opacity-10 blur-3xl" data-id="element-20"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="prose prose-lg md:prose-xl mx-auto text-gray-200 font-sans text-center md:text-left" data-id="element-22">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-inkova-accent mb-10 text-center" data-id="element-23">
            Inkova no nació de&nbsp;la&nbsp;teoría.
          </h2>

          <p className="mb-6 font-light" data-id="element-24">
            Nació de saber lo que es empezar sin&nbsp;saber&nbsp;cómo.
          </p>

          <p className="mb-8 font-light" data-id="element-25">
            De buscar información y encontrar confusión. De preguntar y recibir
            respuestas a medias. De equivocarse y tener que
            volver&nbsp;a&nbsp;comenzar.
          </p>

          <div className="bg-white/10 p-8 rounded-2xl border border-white/20 backdrop-blur-sm my-10 text-left text-sm md:text-base" data-id="element-26">
            <p className="mb-3 font-light" data-id="element-27">
              Soy Annysol Navarro. Comunicadora Social, especialista
              en&nbsp;Relaciones Públicas y&nbsp;Publicidad, diseñadora, Notaria
              certificada en&nbsp;Florida y&nbsp;certificada
              en&nbsp;Bookkeeping.
            </p>
            <p className="mb-3 font-light" data-id="element-28">
              He acompañado por más de&nbsp;8&nbsp;años a&nbsp;emprendedores
              y&nbsp;negocios en&nbsp;Estados Unidos, incluyendo
              la&nbsp;creación de&nbsp;empresas y&nbsp;manejo de&nbsp;cuentas
              de&nbsp;alto valor, con&nbsp;orden, criterio
              y&nbsp;total&nbsp;confidencialidad.
            </p>
            <p className="mb-3 font-light" data-id="element-29">
              He visto lo que muchas personas hacen mal
              al&nbsp;abrir&nbsp;empresas:
            </p>
            <ul className="list-disc list-inside space-y-1.5 mb-5 font-light text-white/90" data-id="element-30">
              <li data-id="element-31">
                Cualquiera puede abrir una empresa, pero nadie te&nbsp;dice qué
                tipo de&nbsp;estructura necesitas para cumplir
                con&nbsp;el&nbsp;IRS.
              </li>
              <li data-id="element-32">No te guían paso&nbsp;a&nbsp;paso.</li>
              <li data-id="element-33">
                No te explican qué necesitas para abrir
                la&nbsp;cuenta&nbsp;bancaria.
              </li>
              <li data-id="element-34">
                No van contigo de&nbsp;la&nbsp;mano, apoyándote
                hasta&nbsp;el&nbsp;final.
              </li>
              <li data-id="element-35">
                Y al final, te dejan sin saber qué hacer luego de&nbsp;crear
                la&nbsp;empresa.
              </li>
            </ul>
            <p className="font-medium text-white text-base md:text-lg" data-id="element-36">
              Por eso, mi enfoque es&nbsp;diferente: te&nbsp;acompaño desde
              la&nbsp;idea inicial hasta que tu&nbsp;negocio está listo
              para&nbsp;operar, con&nbsp;estructura sólida y&nbsp;una hoja
              de&nbsp;ruta&nbsp;clara.
            </p>
          </div>

          <p className="mb-8 text-2xl font-serif text-inkova-accent text-center" data-id="element-37">
            La diferencia es enorme. Por eso&nbsp;creé&nbsp;Inkova.
          </p>

          <p className="mb-6 font-light text-center" data-id="element-38">
            No para ser una más del montón. Sino para ser lo que muchas veces
            nos hizo falta&nbsp;al&nbsp;iniciar:
          </p>

          <div className="bg-inkova-accent text-inkova-primary p-8 rounded-2xl shadow-xl text-center font-medium text-xl md:text-2xl leading-relaxed mt-10" data-id="element-39">
            Un lugar donde el emprendedor latino encuentra claridad, dirección
            y&nbsp;acompañamiento&nbsp;real.
            <br data-id="element-40" />
            <br data-id="element-41" />
            <span className="font-light text-lg md:text-xl" data-id="element-42">
              Desde el primer paso hasta tener un negocio que funciona, que se
              ve profesional y que está listo&nbsp;para&nbsp;crecer.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}